var React = require('react');

function ArrowDown16Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow-down-16","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("polygon",{"id":"Icon","transform":"translate(8.000000, 8.500000) rotate(-90.000000) translate(-8.000000, -8.500000) ","points":"11.5 3.90176105 10.1581397 2.5 4.5 8.5 10.1581397 14.5 11.5 13.0982389 7.18372051 8.5"})));
}

ArrowDown16Inline.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16"};

module.exports = ArrowDown16Inline;

ArrowDown16Inline.default = ArrowDown16Inline;
